import Soon from "./Soon.react"
import Loading from "./Loading.react"
import Container from "./PlaceholderContainer.react"

const content = { Soon, Loading, Container }

export default content
